require([
	'root/Base/Js/Vendor/Modernizr'
], function(

) {
	'use strict';
	// normally nothing else than Modernizr should happen in header
});
define("Assets/Js/Header.js", function(){});

